import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {
  private translate = inject(TranslateService);

  public getErrorMessage(error?: any) {
    const message = error?.error?.detail;
    if (message) {
      return message;
    }
    const errorCode = error?.error?.type;
    if (!errorCode) {
      return this.translate.instant('ERROR.UNKNOWN');
    }
    return this.translate.instant(`ERROR.${errorCode}`);
  }

  public getErrorCode(error: any) {
    return error?.error?.type ?? 'UNKNOWN';
  }
}
